import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { NgxsModule } from '@ngxs/store';
import { NgxsStoragePluginModule } from '@ngxs/storage-plugin';
import { BrowserModule } from '@angular/platform-browser';
import { LOCALE_ID, NgModule } from '@angular/core';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AppRoutingModule } from './app-routing.module';
import { LayoutModule } from './views/layout/layout.module';
import { AppComponent } from './app.component';
import { ErrorPageComponent } from './views/modules/error-page/error-page.component';
import { HIGHLIGHT_OPTIONS } from 'ngx-highlightjs';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { TokenInterceptor } from './services/interceptors/token.interceptor';
import { environment } from 'src/environments/environment';
import { NgxsReduxDevtoolsPluginModule } from '@ngxs/devtools-plugin';
import { SessionState } from './services/state/session.state';
import { SelectedClinicInterceptor } from './services/interceptors/selected-clinic.interceptor';
import { AuthGuard } from './guards/auth.guard';
import { NgbDateAdapter, NgbDateParserFormatter, NgbModule, NgbTimeAdapter } from '@ng-bootstrap/ng-bootstrap';
import { CustomDateAdapterService } from './services/utils/date-picker/custom-date-adapter/custom-date-adapter.service';
import { CustomDateParserFormatterService } from './services/utils/date-picker/custom-date-parser-formatter/custom-date-parser-formatter.service';
import { DatafieldsComponentsModule } from './views/shared/components/datafields/datafields-components.module';
import { FeahterIconModule } from './core/feather-icon/feather-icon.module';
import { TimePickerAdapterService } from './services/utils/time-picker/time-picker-adapter/time-picker-adapter.service';
import { AutofocusFixModule } from 'ngx-autofocus-fix';
import { registerLocaleData } from '@angular/common';
import localePt from '@angular/common/locales/pt'
import { SpinnerModule } from './views/shared/components/spinner/spinner.module';
import { CDK_DRAG_CONFIG } from '@angular/cdk/drag-drop';
import { SearchInputModule } from './views/shared/components/filters/search-input/search-input.module';
import { PaginationModule } from './views/shared/components/pagination/pagination.module';
import { AddButtonModule } from './views/shared/components/buttons/add-button/add-button.module';
import { EditButtonModule } from './views/shared/components/buttons/edit-button/edit-button.module';
import { DeleteButtonModule } from './views/shared/components/buttons/delete-button/delete-button.module';



registerLocaleData(localePt)

@NgModule({
	declarations: [
		AppComponent,
		ErrorPageComponent,
	],
	imports: [
		BrowserModule,
		BrowserAnimationsModule,
		LayoutModule,
		MatSnackBarModule,
		NgbModule,
		FeahterIconModule,
		AutofocusFixModule.forRoot(),
		SpinnerModule,
		//Http module import:

		HttpClientModule,
		AppRoutingModule,
		DatafieldsComponentsModule,
		NgxsModule.forRoot([SessionState], { developmentMode: !environment.production }),
		NgxsStoragePluginModule.forRoot({
			key: ['session']
		}),
		NgxsReduxDevtoolsPluginModule.forRoot(),
	],
	providers: [
		AuthGuard,
		{
			provide: HIGHLIGHT_OPTIONS, // https://www.npmjs.com/package/ngx-highlightjs
			useValue: {
				coreLibraryLoader: () => import('highlight.js/lib/core'),
				languages: {
					xml: () => import('highlight.js/lib/languages/xml'),
					typescript: () => import('highlight.js/lib/languages/typescript'),
					scss: () => import('highlight.js/lib/languages/scss')
				}
			}
		},
		{
			provide: NgbTimeAdapter,
			useClass: TimePickerAdapterService
		},
		{
			provide: HTTP_INTERCEPTORS,
			useClass: TokenInterceptor,
			multi: true
		},
		{
			provide: HTTP_INTERCEPTORS,
			useClass: SelectedClinicInterceptor,
			multi: true
		},
		{
			provide: NgbDateAdapter,
			useClass: CustomDateAdapterService
		},
		{
			provide: NgbDateParserFormatter,
			useClass: CustomDateParserFormatterService
		},
		{
			provide: CDK_DRAG_CONFIG, useValue: {
				dragStartThreshold: 0,
				pointerDirectionChangeThreshold: 5,
				zIndex: 10000
			}
		},
		{
			provide: LOCALE_ID,
			useValue: 'pt'
		}
	],
	bootstrap: [AppComponent]
})
export class AppModule { }
